import styled from "styled-components";



export const ArrangementSection = styled.section`
border-top: 1px solid rgba(229,238,238,.992);
border-bottom: 1px solid rgba(229,238,238,.992);
margin-top: 1.875rem;

.arrangement-section__content{
	margin-top: 3.75rem;
	display: flex;
	flex-direction: row;
	

	& div {
		width: 49%;
		padding-left: 3.75rem;
		border-left: 4px solid rgb(7, 66, 117);
		height: 7.5rem;
		display: flex;
		align-items: center;
	}

	@media(max-width:1455px){
		height: 11rem;
	}
	@media(max-width:998px){
		height: 15rem;
	}
	@media(max-width:768px){
		flex-direction: column;
		height: auto;
		

		:first-child {
				border-bottom: 4px solid rgb(7, 66, 117);
				margin-bottom: 1.25rem;
				padding-bottom: 1.25rem;
			}
		& div{
			width: 100%;
			border-left: none;
			padding: 0;
			height: auto;
		}
	}
}
`

export const FeaturesStockTradingSection = styled.section`

.top__content{
	& div{
		margin: 3.75rem 0rem;
	}
	& p{
	width: 48%;
	}
}
.cards{
	display: flex;
	flex-wrap: wrap;
& div {
	width: 32%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
}

@media(max-width:768px){
	.top__content{
		& div{
			flex-direction: column;
			:first-child{
				margin-bottom: 1.25rem;
			}
		}
		& p {
			width: 100%;
		}
	}
	.cards{
		& div {
			width: 100%;
			
		}
		:not(:last-child){
				margin-bottom: 1.25rem;
			}
	}
}
`

export const ProsCostSection = styled.section`
background: #001b48;
color: #fff;

& h2{
	margin-bottom: 3.75rem;
}
& p{
margin: 1.25rem 0rem;
}

.pros-cost__cards{
margin-top: 3.75rem;
	& h4{
	color: #219453;
	}
	.red__title{
		color: #e95858;
	}
	& div {
		padding: 3.75rem;
		background-color: #fff;
		color: #000;
		width: 49%;
		height: 16.25rem;
	}
	& span{
		display: inline-block;
		height: 5px;
		width: 1.875rem;
		background-color: #219453;
	}
	.red__span{
		background-color: #e95858;
	}
	& ul{
		margin-top: 5px;
	}

	@media(max-width:1210px){
		& div {
			height: 22.5rem;
		}
	}

	@media(max-width:768px){
		display: flex;
		flex-direction: column;

		& div:first-child{
			margin-bottom: 1.25rem;
		}

		& div {
			width: 100%;
			height: auto;
			padding: 2rem;
		}
	}
}
`

export const LinksSections = styled.section`

padding: 3.75rem 0rem;
border-top: 1px solid rgba(229,238,238,.992);
border-bottom: 1px solid rgba(229,238,238,.992);
margin-bottom: 2.5rem;

.links-section__content{

display: flex;
flex-wrap: wrap;

	& div{
		width: 49%;
		background-color: #001b48;
		color: #fff;
		padding: 3.75rem;
	}
	& p{
		font-size: 1.25rem;
		font-weight: 700;
	}
	& a{
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: transparent;
		padding: 1.25rem;
		width: 11.25rem;
		border: 2px solid #fff;
		margin-top: 1.875rem;
		font-weight: 700;
	}
}

@media(max-width:768px){

padding: 0.75rem 0rem;

	.links-section__content{
		& div{
			width: 100%;
			padding: 1.75rem;
		}
			& div:first-child{
				margin-bottom: 1.25rem;
			}
		}
	}
		
`

